;(function () {
	const normalizePath = (pathname) => {
		if (!pathname || pathname === '/') return '/'
		return pathname.replace(/\/$/, '') || '/'
	}

	const getHeaderOffset = () => {
		const raw = getComputedStyle(document.documentElement).getPropertyValue(
			'--header-height'
		)
		const parsed = parseFloat(raw)
		return Number.isFinite(parsed) ? parsed : 80
	}

	/**
	 * Highlight desktop nav items whose href is a same-page hash (#pricing)
	 * only while that section is in the sticky-header viewport band.
	 */
	const initMenuScrollSpy = () => {
		const nav = document.querySelector('.header__inline-menu')
		if (!nav) return

		const anchorLinks = [
			...nav.querySelectorAll('a.header__menu-item[data-menu-anchor]'),
		]
		if (!anchorLinks.length) return

		const pairs = []
		for (const link of anchorLinks) {
			const id = link.dataset.menuAnchor
			if (!id) continue

			let url
			try {
				url = new URL(link.href, window.location.href)
			} catch {
				continue
			}

			if (normalizePath(url.pathname) !== normalizePath(window.location.pathname)) {
				continue
			}

			const target = document.getElementById(id)
			if (!target) continue
			pairs.push({ link, target, id })
		}

		if (!pairs.length) return

		const clearActive = () => {
			for (const { link } of pairs) {
				link.classList.remove('header__menu-item--active')
				link.removeAttribute('aria-current')
			}
		}

		const setActive = (activeLink) => {
			clearActive()
			if (!activeLink) return
			activeLink.classList.add('header__menu-item--active')
			activeLink.setAttribute('aria-current', 'location')
		}

		const syncFromHash = () => {
			const hash = (window.location.hash || '').replace(/^#/, '')
			if (!hash) {
				clearActive()
				return
			}
			const match = pairs.find(({ id }) => id === hash)
			setActive(match ? match.link : null)
		}

		let intersecting = new Set()

		const pickActiveFromIntersecting = () => {
			if (!intersecting.size) {
				clearActive()
				return
			}

			let best = null
			let bestTop = Infinity
			for (const { link, target } of pairs) {
				if (!intersecting.has(target)) continue
				const top = target.getBoundingClientRect().top
				if (top < bestTop) {
					bestTop = top
					best = link
				}
			}
			setActive(best)
		}

		const rebuildObserver = () => {
			if (nav._menuScrollSpyObserver) {
				nav._menuScrollSpyObserver.disconnect()
			}

			const offset = getHeaderOffset()
			const observer = new IntersectionObserver(
				(entries) => {
					for (const entry of entries) {
						if (entry.isIntersecting) {
							intersecting.add(entry.target)
						} else {
							intersecting.delete(entry.target)
						}
					}
					pickActiveFromIntersecting()
				},
				{
					root: null,
					// Top band under sticky header; bottom ignored so one section owns "current"
					rootMargin: `-${Math.round(offset + 4)}px 0px -55% 0px`,
					threshold: [0, 0.1, 0.25, 0.5],
				}
			)

			for (const { target } of pairs) {
				observer.observe(target)
			}
			nav._menuScrollSpyObserver = observer
		}

		for (const { link, id } of pairs) {
			link.addEventListener('click', () => {
				setActive(link)
			})
		}

		window.addEventListener('hashchange', syncFromHash)
		window.addEventListener(
			'resize',
			() => {
				window.clearTimeout(nav._menuScrollSpyResize)
				nav._menuScrollSpyResize = window.setTimeout(rebuildObserver, 150)
			},
			{ passive: true }
		)

		clearActive()
		rebuildObserver()
		if (window.location.hash) {
			syncFromHash()
		}
	}

	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		let hideMenuTimeout

		if (!header) return

		initMenuScrollSpy()

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search && search.isOpen) {
				search.close()
			}
		})

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		const megaMenus = document.querySelectorAll('.mega-menu')

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				clearTimeout(hideMenuTimeout)

				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return

					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'grid'
							setTimeout(() => {
								megaMenu.style.opacity = 1
							}, 100)
						}

						const headerMain = header.querySelector('.header')

						const calcPosition = () => {
							megaMenu.style.right = 'auto'

							const megaMenuTabs = megaMenu.querySelector('.mega-menu__tabs')

							if (megaMenuTabs) {
								if (megaMenuTabs.scrollWidth > megaMenu.offsetWidth) {
									megaMenu.style.maxWidth = `${megaMenuTabs.scrollWidth}px`
									megaMenu.style.width = `${megaMenuTabs.scrollWidth}px`
								}
							}

							const megaMenuRight = megaMenu.getBoundingClientRect().right
							const headerRight = headerMain.getBoundingClientRect().right

							if (megaMenuRight > headerRight) {
								megaMenu.style.right = '2rem'
							}
						}

						calcPosition()

						let headerMainWidth = headerMain.offsetWidth

						const resizeObserver = new ResizeObserver((entries) => {
							for (const entry of entries) {
								const newWidth = entry.contentRect.width

								if (newWidth !== headerMainWidth) {
									headerMainWidth = newWidth
									calcPosition()
								}
							}
						})

						resizeObserver.observe(headerMain)
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
			link.addEventListener('mouseleave', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						if (megaMenu == link.querySelector('.mega-menu')) {
							megaMenu.style.opacity = 0
							megaMenu.style.display = 'none'
							hideMenuTimeout = setTimeout(() => {
								megaMenu.style.display = 'none'
							}, 100)
						}
					})
				}
			})
			link.addEventListener('focus', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					link.classList.add('list-menu--megamenu-visible')

					if (!megaMenus) return
					megaMenus.forEach((megaMenu) => {
						const megaMenuPositionRight = megaMenu.getBoundingClientRect().right
						const windowRight = window.innerWidth
						if (megaMenuPositionRight > windowRight) {
							megaMenu.style.right = '0'
						}
					})

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})
		menu.addEventListener('mouseleave', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
					megaMenu.style.display = 'none'
				})
			}, 100)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})
		menu.addEventListener('focusout', (e) => {
			if (!megaMenus) return
			setTimeout(() => {
				megaMenus.forEach((megaMenu) => {
					megaMenu.style.right = 'auto'
				})
			}, 500)
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0] &&
			main
				.querySelectorAll('.shopify-section')[0]
				.classList.contains('section--has-overlay')
		) {
		}

		const menuCloseBtn = document.querySelector('.header__modal-close-button')
		const mobileMenuDrawer = document.querySelector('header-drawer')
		menuCloseBtn.addEventListener('click', (e) => {
			mobileMenuDrawer.closeMenuDrawer(e)
		})
	}

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)

	header()
})()
